export default "__VITE_ASSET__CIHnijAV__"